import React, {useEffect, useState} from "react";
import clone from "lodash.clonedeep";
import {Button, ControlLabel, FormGroup, Glyphicon} from "react-bootstrap";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {
    getEpisodePartners,
    createEpisodePartner,
    updateEpisodePartner,
    removeEpisodePartner,
    updateEpisodePartnersOrder,
} from "../../../../../api/cp";
import {Event} from "../../../Comet";
import PartnerEditModals from "../EditModals/PartnerEditModals";
import DraggableBlock from "../components/DraggableBlock";

import "./styles.scss";

const Partners = ({episode}) => {
    const [partners, setPartners] = useState([]);
    const [editablePartner, setEditablePartner] = useState(null);
    const [isEditModalVisible, setEditModalVisible] = useState(false);

    useEffect(() => {
        setPartners(episode.partners);
    }, [episode]);

    async function fetchEpisodePartners() {
        try {
            const response = await getEpisodePartners(episode.id);
            setPartners(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleSavePartner = async (partner) => {
        try {
            const formData = new FormData();
            Object.keys(partner).forEach(key => formData.append(key, partner[key]));

            const response = await createEpisodePartner(episode.id, formData);
            setPartners((prevState) => ([...prevState, response]));
        } catch (error) {
            console.error(error);
        }
    }

    const handleUpdatePartner = async (partner) => {
        try {
            const formData = new FormData();
            Object.keys(partner).forEach(key => formData.append(key, partner[key]));

            await updateEpisodePartner(partner.id, formData);
            fetchEpisodePartners();
        } catch (error) {
            console.error(error);
        }
    }

    const handleDeletePartner = async (id) => {
        try {
            await removeEpisodePartner(id);
            fetchEpisodePartners();
        } catch (error) {
            console.error(error);
        }
    }

    const handleOpenModal = (partner) => {
        setEditModalVisible(true);
        setEditablePartner(partner);
    }

    const updatePartnersList = async (list) => {
        try {
            setPartners(list);
            const payload = list.map(({id}) => id);
            await updateEpisodePartnersOrder(episode.id, payload);
        } catch (error) {
            console.error(error);
        }
    }

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedTags = reorder(
            partners,
            result.source.index,
            result.destination.index,
        );

        updatePartnersList(reorderedTags);
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    const handleCometEpisodeUpdate = (episode) => {
        setPartners(episode.partners);
    }

    return (
        <section style={{marginTop: '12px'}}>
            <Event event="update:episode" handler={handleCometEpisodeUpdate} />
            <div>
                <FormGroup>
                    <ControlLabel style={{display: 'block'}}>Партнеры</ControlLabel>
                    <Button onClick={() => setEditModalVisible(true)}>
                        <Glyphicon glyph="folder-open" />{' '}
                        Добавить
                    </Button>
                </FormGroup>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {partners?.map((partner, index) => (
                                    <Draggable
                                        key={partner.id}
                                        draggableId={`${partner.id || index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={
                                                    provided.draggableProps.style
                                                }
                                            >
                                                <DraggableBlock
                                                    block={partner}
                                                    onEdit={handleOpenModal}
                                                    onDelete={handleDeletePartner}
                                                >
                                                    <img
                                                        src={partner?.logoUrl}
                                                        style={{maxWidth: '100px'}}
                                                    />
                                                    <a
                                                        href={partner?.link}
                                                        target="_blank"
                                                    >
                                                        {partner?.link}
                                                    </a>
                                                </DraggableBlock>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                <PartnerEditModals
                    editablePartner={editablePartner}
                    show={isEditModalVisible}
                    onSave={handleSavePartner}
                    onUpdate={handleUpdatePartner}
                    onClose={() => {
                        setEditModalVisible(false);
                        setEditablePartner(null);
                    }}
                />
            </div>
        </section>
    );
};

export default Partners;
